import { Theme, makeStyles } from '@forgeglobal/design-framework';

export const hasScrollBoxMediaQuery = '@media (min-height: 700px)';

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: `${theme.spacing(7, 4, 2)} !important`,
    transition: theme.transitions.create('padding'),
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(5, 2, 2)} !important`,
    },
  },
  title: {
    textAlign: 'center',
  },
  description: {
    maxWidth: 550,
    margin: theme.spacing(0, 'auto', 2),
    textAlign: 'center',
    fontWeight: 400,
    lineHeight: '24px',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(2),
  },
  narrowButton: {
    padding: theme.spacing(1.5, 1),
  },
  container: {
    [hasScrollBoxMediaQuery]: {
      height: 400,
    },
    overflow: 'auto',
    padding: '16px 16px 0 16px',
  },
}));

export default useStyles;
